<template lang="pug">
Fragment
  .loading-container( v-if="loading" )
    b-spinner( label="Loading..." variant="primary" )
  div( v-show="!loading" )
  b-row
    b-col(cols='1')
      BackArrow
    b-col(cols='11').d-flex.flex-column.align-items-start.mb-2
      h4.title Excepciones
      nav.breadcrumb-custom
        span Inicio
        span.separator /
        span Excepciones
  ListException( @stop-loading="loading = false" )
</template>

<script>
import ListException from '../components/Excepcion/List.vue'
import BackArrow from '../components/UI/BackArrow.vue'

export default {
  name: 'Excepciones',
  components: {
    ListException,
    BackArrow,
  },
  data() {
    return {
      loading: true,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

.title {
  color: $samtek-black;
  font-size: 20px;
  font-weight: 700;
}

.breadcrumb-custom {
  margin-top: 8px;
  font-size: 15px;
  color: $samtek-grey;
}

.breadcrumb-custom .separator {
  margin: 0 6px;
}

::v-deep .back-arrow {
  color: $samtek-yellow !important;
  font-size: 24px;
  border-radius: 5px;
}
</style>
